export default function PostDate({ dateString }: { dateString: string }) {
	return <time dateTime={dateString}>{dateString}</time>;
}
